import { MdOutlineOpenInNew } from 'react-icons/md'
import { useLocation } from 'react-router-dom'
import { portalHref } from '../portal'
import { ShellMessage } from '../ShellMessage'

export interface PortalNoticeProps {
  /** Defaults to `APP_PORTAL_URL`. */
  portalUrl?: string | undefined
}

/**
 * The page for a direct visit to an area not in `APP_PORTED_AREAS`
 * (ADR 0017): a link to the same path, query and hash in the portal.
 */
export function PortalNotice({ portalUrl = import.meta.env.APP_PORTAL_URL }: PortalNoticeProps) {
  const { pathname, search, hash } = useLocation()
  const href = portalHref(`${pathname}${search}${hash}`, portalUrl)
  return (
    <ShellMessage title="This screen is still in the portal" icon={<MdOutlineOpenInNew />}>
      <p>This part of Oase Admin has not moved to the new app yet.</p>
      {href ? (
        <p>
          <a href={href}>Open this page in the Oase Admin Portal</a>
        </p>
      ) : (
        <p>The portal address is not configured for this environment.</p>
      )}
    </ShellMessage>
  )
}
